
import DashboardStats from '../components/dashboardStats.vue';
export default {
  components: {
    DashboardStats: DashboardStats
  },
  data: function data() {
    return {};
  },
  mounted: function mounted() {}
};